import { render } from "./BillsRaised.vue?vue&type=template&id=58b6ae64&scoped=true"
import script from "./BillsRaised.vue?vue&type=script&lang=js"
export * from "./BillsRaised.vue?vue&type=script&lang=js"

import "./BillsRaised.vue?vue&type=style&index=0&id=58b6ae64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b6ae64"]])

export default __exports__